
<template>

	<div class="content">

	<el-container> 
			

			<div class="wraper_img"> 
				<img src="/static/images/erweima.jpg" alt="customer service">
        <p>扫描二维码获取客服支持</p>
			</div>
		</el-container>

		<navBar :idx="2"></navBar>
	</div>

	
</template>




<script>
import navBar from '@/components/navBar';

export default {
	name: 'customer',
	components:{
		navBar,
	},	
}
</script>


<style scoped>
.content{

}
.wraper_img{
  text-align:center;
  margin:0 auto;
  transform:translateY(50%)
}
.wraper_img img{
  width:200px;
  height:200px;
  margin:0 auto;
}

</style>


// WEBPACK FOOTER //
// src/page/customer.vue